import rules from "../../utils/wordSpiderRules";
import type { WordSpiderCell } from "./types";
export interface WordScoreDetail {
  word: string;
  score: number;
}
export interface ScoreResult {
  score: number;
  validWords: string[];
  invalidWords: string[];
  wordScores: WordScoreDetail[];
  isValid: boolean;
}
export function calculateScore(
  board: (WordSpiderCell | null)[][],
): ScoreResult {
  return rules.calculateScore(board);
}
export function checkConnectivity(board: (WordSpiderCell | null)[][]): boolean {
  return rules.checkConnectivity(board);
}
